import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../../Constants";
import { authFetch } from "../../../../utils/authFetch";

const CallCenterList = () => {
  const [callCenters, setCallCenters] = useState([]);
  const [viewMode, setViewMode] = useState("table");
  const navigate = useNavigate();

  const fetchCallCenters = async () => {
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/callcenter/callcenterlist/callcenters`,
        {
          method: "GET",
        }
      );
      setCallCenters(response);
    } catch (error) {
      console.error("Fetch error: ", error);
    }
  };

  useEffect(() => {
    fetchCallCenters();
  }, []);

  const handleEdit = (id) => {
    navigate(`/call-center/edit-callcenterlist/${id}`); // Passing ID to the edit page
  };

  const handleDelete = async (id) => {
    try {
      await fetch(
        `${API_BASE_URL}/api/callcenter/callcenterlist/callcenters/${id}`,
        {
          method: "DELETE",
          credentials: "include",
        }
      );
      alert("Call Center deleted successfully");
      fetchCallCenters(); // Refresh list after deletion
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to delete call center");
    }
  };

  return (
    <div className="mx-auto ml-4 h-screen w-full mt-14">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Call Center List</h2>
        <label className="flex items-center">
          <span className="mr-2">View Mode:</span>
          <select
            value={viewMode}
            onChange={(e) => setViewMode(e.target.value)}
            className="px-4 mr-10 py-1 border rounded-md"
          >
            <option value="table">Table</option>
            <option value="card">Card</option>
          </select>
        </label>
      </div>

      {viewMode === "table" ? (
        <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">
                Dispatch Number
              </th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">
                Building Site
              </th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">
                Device ID
              </th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">
                Customer Number
              </th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">
                Dispatch Type
              </th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">
                Mechanic(s)
              </th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">
                Actual Hours
              </th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">
                Reg Hours
              </th>
              <th className="px-4 py-2 text-left font-semibold text-gray-600">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {callCenters.map((callCenter, key) => (
              <tr key={key} className="border-t">
                <td className="px-4 py-2">{callCenter.dispatchNumber}</td>
                <td className="px-4 py-2">{callCenter.buildingSite}</td>
                <td className="px-4 py-2">{callCenter.deviceId}</td>
                <td className="px-4 py-2">{callCenter.customerNumber}</td>
                <td className="px-4 py-2">{callCenter.dispatchType}</td>
                <td className="px-4 py-2">{callCenter.mechanics}</td>
                <td className="px-4 py-2">{callCenter.actualHours}</td>
                <td className="px-4 py-2">{callCenter.regHours}</td>
                <td className="px-4 py-2">
                  <button
                    className="text-blue-600 mr-2"
                    onClick={() => handleEdit(callCenter.id)} // Clicking Edit will pass the ID to the edit route
                  >
                    Edit
                  </button>
                  <button
                    className="text-red-600"
                    onClick={() => handleDelete(callCenter.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {callCenters.map((callCenter, key) => (
            <div
              key={key}
              className="bg-white p-4 rounded-lg shadow-lg border-2 border-gray-200 flex items-center"
            >
              <img
                src="/favicon.ico"
                alt="Profile"
                className="w-16 h-16 rounded-full mr-4"
              />
              <div className="flex-1">
                <h3 className="text-lg font-semibold">
                  #{callCenter.dispatchNumber} {callCenter.dispatchDate}
                </h3>
                <p className="text-sm text-gray-600">
                  {callCenter.buildingSite}
                </p>
                <div className="flex mt-2">
                  <button
                    className="text-blue-600 mr-2"
                    onClick={() => handleEdit(callCenter.id)}
                  >
                    Edit
                  </button>
                  <button
                    className="text-red-600"
                    onClick={() => handleDelete(callCenter.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CallCenterList;
